// gatsby-browser.js
import { ThemeProvider as UserPreferenceThemeProvider } from 'next-themes';
import { ThemeProvider } from 'styled-components';

import { CaptureAttribution } from '@/utils';
import { DARK_THEME } from '@/utils/theme/themes';

export const wrapRootElement = ({ element }) => {
  return (
    <CaptureAttribution>
      <ThemeProvider theme={DARK_THEME}>{element}</ThemeProvider>
    </CaptureAttribution>
  );
};

export const wrapPageElement = ({ element }) => {
  return (
    <UserPreferenceThemeProvider
      forcedTheme={element.type.supportsLightDark ? null : 'dark'}>
      {element}
    </UserPreferenceThemeProvider>
  );
};
